module.exports = __webpack_public_path__ + "static/fonts/Arial-Italic.fc5a615c.ttf";